import React from 'react';
import { Typography, Stack } from '@mui/material';
import Link from 'next/link';

import WrappedButton from '@/components/ui/WrappedButton';
import WrappedModal from '@/components/ui/WrappedModal';

interface SignOutModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  playerPendingClaimRewards: any[];
  t: (key: string, options?: any) => string;
}

const SignOutModal: React.FC<SignOutModalProps> = ({
  open,
  onClose,
  onConfirm,
  playerPendingClaimRewards,
  t,
}) => {
  return (
    <WrappedModal
      title={t('Sign out')}
      open={open}
      onClose={onClose}
    >
      <Stack gap={2}>
        {playerPendingClaimRewards.length > 0 && (
          <Typography>
            {t('You still have {{amount}} rewards to be claimed!', {
              amount: playerPendingClaimRewards.length,
            })}
            &nbsp;
            <Link href={'/benefits/deposit'} onClick={onClose}>
              <Typography component={'span'} color={'primary.main'}>
                {t('Claim Now')}
              </Typography>
            </Link>
          </Typography>
        )}
        
        <Typography>{t('Are you sure you want to sign out?')}</Typography>
        
        <Stack direction="row" spacing={2}>
          <WrappedButton
            fullWidth
            variant="plain"
            onClick={onClose}
          >
            {t('Cancel')}
          </WrappedButton>
          <WrappedButton
            fullWidth
            onClick={onConfirm}
          >
            {t('OK')}
          </WrappedButton>
        </Stack>
      </Stack>
    </WrappedModal>
  );
};

export default SignOutModal; 